import React, {FC} from "react";
import cls from "./shared.module.scss"
import {InputMinus, InputPlus} from "../../svg";

interface IProps {
    id?: string,
    min: number;
    max?: number;
    step?: number;
    value: number;
    className?: string;
    size?: string
    onChange?: (arg: number) => void
    hideMinusButton?: boolean
    disabled?: boolean
    style?: any,
    alternativelyRemoveButton?: JSX.Element,
}

const InputNumber: FC<IProps> = ({
                                     min = null,
                                     size,
                                     onChange,
                                     hideMinusButton,
                                     className,
                                     alternativelyRemoveButton,
                                     value,
                                     step = 1,
                                     max = null,
                                     ...otherProps
                                 }) => {
    const handleChange = (event: { target: { value: string; }; }) => {
        if (onChange) {
            if (event.target.value.trim() === "") {
                onChange(Number(""));
            } else {
                const value = parseFloat(event.target.value);

                onChange(Number.isNaN(value) ? min || 0 : value);
            }
        }
    }

    const handleAddSubMouseDown = (arg: number) => {
        change(arg);
        changeByTimer(arg);
    };

    const change = (direction: number) => {
        let newValue =
            (!value || Number.isNaN(value) ? 0 : value) + step * direction;

        if (max !== null) {
            newValue = Math.min(max, newValue);
        }
        if (min !== null) {
            newValue = Math.max(min, newValue);
        }

        if (newValue !== value) {
            if (onChange) {
                onChange(newValue);
            }
        }
    }

    const changeByTimer = (direction: number) => {

        let interval: any;
        const timer = setTimeout(() => {
            interval = setInterval(() => change(direction), 50);
        }, 3000);

        const documentMouseUp = () => {
            clearTimeout(timer);
            clearInterval(interval);

            document.removeEventListener("mouseup", documentMouseUp, false);
        };

        document.addEventListener("mouseup", documentMouseUp, false);
    }

    const classes: { [key: string]: string } = {
        true: cls["input-number"],
        false: `${cls["input-number"]} ${className || ""}`,
    };

    const formControlClasses = {
        true: `${cls["input-number__input"]}  ${cls["cart-quantity-responsive"]}`,
        false: `${cls["input-number__input"]}  ${cls["cart-quantity-responsive"]} ${cls["form-control-sm"]}`
    }

    const minusButton = {
        true: alternativelyRemoveButton,
        false: <button type='button' style={{background: 'linear-gradient(180deg, #EEE 0%, #D5D5D5 100%)'}}>
            <InputMinus
                className={hideMinusButton ? cls["minus_hide"] : cls["input-number__sub"]}
                onMouseDown={() => handleAddSubMouseDown(-1)}
            />
        </button>
    }

    return (
        <div className={classes[`${!!className}`]}>

            {minusButton[`${!!hideMinusButton}`]}

            <input
                className={formControlClasses[`${size === "sm"}`]}
                type="number"
                onChange={handleChange}
                value={value}
                style={{width: "60px"}}
                {...otherProps}
            />
            <button type='button' style={{background: 'linear-gradient(180deg, #EEE 0%, #D5D5D5 100%)'}}>
                <InputPlus
                    className={cls["input-number__add"]}
                    onMouseDown={() => handleAddSubMouseDown(1)}
                />
            </button>
        </div>
    );
}

export default InputNumber;
